<template>
  <div class="login" v-title data-title="北京天蔚中医药发展促进中心-注册">
    <section class="form_container">
      <el-form
        :model="loginUser"
        :rules="rules"
        ref="loginForm"
        class="loginForm"
        label-width="70px"
        style="margin-top:30px;padding-top:30px"
      >
        <el-form-item>
          <div class="login_title">
            <img src="../assets/logo.png" alt />
            <h1>北京天蔚中医药发展促进中心</h1>
            <p>BEIJING TIANWEI PROMOTION CENTER</p>
            <div class="line"></div>
            <h3>
              *
              注册项目管理账户需补充完整个人信息，经过审核后，我们会将结果信息在一个工作日内发送至你的手机。
            </h3>
          </div>
        </el-form-item>
        <el-form-item prop="name">
          <el-input
            clearable
            v-model="loginUser.name"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="dwName">
          <el-input
            clearable
            v-model="loginUser.dwName"
            placeholder="单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input
            clearable
            v-model="loginUser.email"
            placeholder="邮箱"
          ></el-input>
        </el-form-item>
        <div class="sheng">
          <el-form-item prop="sheng">
            <el-select
              @change="selectSheng"
              v-model="loginUser.sheng"
              clearable
              placeholder="请选择省份"
            >
              <el-option
                v-for="item in shengData"
                :key="item.sheng"
                :label="item.sheng"
                :value="item.sheng"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="shi">
            <el-select
              :disabled="shiData.length == 0 ? true : false"
              v-model="loginUser.shi"
              clearable
              placeholder="请选择市区"
            >
              <el-option
                v-for="item in shiData"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item prop="address">
          <el-input
            clearable
            v-model="loginUser.address"
            placeholder="详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="fileShow">
            <span>身份证正面:</span>
            <el-upload
              class="avatar-uploader"
              action="http://123.56.170.62:9999/tianwei/userzheng"
              ref="pictUpload"
              :show-file-list="false"
              list-type="picture-card"
              :on-change="picthandleChange"
              :before-upload="pictbeforeAvatarUpload"
              :auto-upload="false"
              :data="{ phone: loginUser.phone }"
            >
              <img
                v-if="loginUser.zPict"
                :src="loginUser.zPict"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span style="margin-left:0.2rem">身份证反面:</span>
            <el-upload
              class="avatar-uploader"
              action="http://123.56.170.62:9999/tianwei/userfan"
              ref="fpictUpload"
              :show-file-list="false"
              list-type="picture-card"
              :on-change="fpicthandleChange"
              :before-upload="fpictbeforeAvatarUpload"
              :auto-upload="false"
              :data="{ phone: loginUser.phone }"
            >
              <img
                v-if="loginUser.fPict"
                :src="loginUser.fPict"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <!-- <el-form-item prop="path">
          <span>提交身份信息:</span>
          <el-upload
            class="avatar-uploader"
            action="http://123.56.170.62:9999/func/coll"
            ref="pictUpload"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            list-type="picture-card"
            :file-list="pictfileList"
            :on-change="picthandleChange"
            :before-upload="pictbeforeAvatarUpload"
            :auto-upload="false"
          >
            <img
              v-if="loginUser.path"
              :src="loginUser.path"
              style="width: 148px;height: 148px;"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>-->
        <el-form-item>
          <!-- :disabled="isClick" -->
          <el-button
            :type="!isClick ? 'primary' : 'info'"
            @click="submitForm('loginForm')"
            class="submit_btn"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
// import jwt_decode from "jwt-decode";
import { mapState } from "vuex"
import {
  Login,
  Register,
  nextPassword,
  getSheng,
  getReCode,
  getBackCode,
} from "@/api/user.js"
export default {
  name: "login",
  data() {
    return {
      loginUser: {
        dwName: "",
        name: "",
        address: "",
        email: "",
        zPict: "",
        fPict: "",
        phone: "",
        sheng: "",
        shi: "",
      },
      shiData: [],
      shengData: [],
      btnTitle: "",
      disabled: false,
      isClick: false,
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 8, message: "姓名不符合要求", trigger: "blur" },
        ],
        dwName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        sheng: [{ required: true, message: "请选择省份", trigger: "blur" }],
        shi: [{ required: true, message: "请选择市区", trigger: "blur" }],
      },
      pictfileList: [],
      fpictfileList: [],
    }
  },
  mounted() {
    if (this.$route.params.phone) {
      this.getSs()
      this.loginUser.phone = this.$route.params.phone
    } else {
      this.$router.push("/")
    }
  },
  methods: {
    // 获取省市
    async getSs() {
      let sData = await getSheng()
      this.shengData = sData
    },
    selectSheng(sheng) {
      this.shengData.forEach((item) => {
        if (item.sheng == sheng) {
          this.shiData = item.shi
        }
      })
    },
    pictbeforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        console.log(resolve())
        resolve()
      })
    },
    fpictbeforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        resolve()
      })
      //   this.editData.path = URL.createObjectURL(file);
      //   this.programInfo.append('file', file)
      //   // return false
    },
    pictRemove(file, fileList) {
      this.pictfileList = fileList
    },
    picthandleChange(file, fileList) {
      console.log(file, fileList, 1)
      const isJPG =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("身份证图片只能是 png/jpg/jpeg 格式!")
      }
      if (!isLt2M) {
        this.$message.error("身份证图片不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
      } else {
        this.pictfileList = fileList
        this.loginUser.zPict = URL.createObjectURL(file.raw)
      }
    },
    fpicthandleChange(file, fileList) {
      console.log(fileList)
      const isJPG =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("身份证图片只能是 png/jpg/jpeg 格式!")
      }
      if (!isLt2M) {
        this.$message.error("身份证图片不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
      } else {
        this.fpictfileList = fileList
        this.loginUser.fPict = URL.createObjectURL(file.raw)
      }
    },
    // 登录样式
    isClickPhone() {
      if (
        this.isCellPhone(this.loginUser.phone) &&
        this.isVerifyCode(this.loginUser.verifyCode)
      ) {
        this.isClick = false
      } else {
        this.isClick = true
      }
    },
    // 登录注册
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.pictfileList.length == 1 && this.fpictfileList.length == 1) {
            this.$refs.pictUpload.submit()
            this.$refs.fpictUpload.submit()
          } else if (this.pictfileList.length == 0) {
            this.$message.warning("身份证正面未上传")
            return false
          } else if (this.fpictfileList.length == 0) {
            this.$message.warning("身份证反面未上传")
            return false
          }
          let userInfo = new FormData()
          userInfo.append("phone", this.loginUser.phone)
          userInfo.append("name", this.loginUser.name)
          userInfo.append("unit", this.loginUser.dwName)
          userInfo.append("email", this.loginUser.email)
          userInfo.append("sheng", this.loginUser.sheng)
          userInfo.append("shi", this.loginUser.shi)
          userInfo.append("site", this.loginUser.address)
          let reg = await Register(userInfo)
          if (reg.code == "One") {
            this.$message.success("申请成功，请耐心等待审核结果")
            this.pictfileList = []
            this.fpictfileList = []
            this.loginUser = {
              dwName: "",
              name: "",
              address: "",
              email: "",
              zPict: "",
              fPict: "",
              phone: this.$route.params.phone,
            }
            let flag = navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
            if (flag) {
              this.$router.push("/mmain")
            } else {
              this.$router.push("/")
            }
          } else {
            this.$message.error(reg.msg)
          }
        }
      })
    },
    // 获取验证码
    async getVerifyCode(phone) {
      if (this.isCellPhone(phone)) {
        this.validateBtn()
        // 发送网络请求
        let verifyCode = new FormData()
        verifyCode.append("phone", phone)
        let code = await getReCode(verifyCode)
        if (code.code == "ERR") {
          this.$message({
            type: "error",
            message: code.msg,
          })
        }
      } else {
        this.$message({
          type: "warning",
          message: "手机号有误",
        })
      }
    },
    //验证手机号格式
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    //验证验证码
    isVerifyCode(val) {
      if (!/\d{6}$/.test(val) || val.length !== 6) {
        return false
      } else {
        return true
      }
    },
    //倒计时
    validateBtn() {
      let time = 60
      this.disabled = true
      this.btnTitle = time + "秒后重试"
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer)
          this.disabled = false
        } else {
          // 倒计时
          time--
          this.btnTitle = time + "秒后重试"
          this.disabled = true
        }
      }, 1000)
    },
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      )
    },
  },
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url(../assets/newBg.png) no-repeat center center;
  background-size: 100% 100%;
  .form_container {
    width: 520px;
    position: absolute;
    top: 0;
    margin-top: -30px;
    left: calc(50vw - 285px);
    border-radius: 5px;
    text-align: center;
    .loginForm {
      background-color: #fff;
      padding: 0px 60px 1px 0;
      border-radius: 5px;
      box-shadow: 0px 5px 10px #cccc;
      .login_title {
        margin-top: -20px;
        img {
          width: 50px;
          height: 50px;
        }
        h1 {
          font-size: 18px;
          font-weight: 600;
          margin: -10px 0 0px;
        }
        h3 {
          line-height: 1.2;
          text-align: left;
          color: #4accff;
        }
        p {
          margin-bottom: 16px;
          font-size: 11px;
          line-height: 1;
          color: #3d3d3d;
        }
        .line {
          height: 1px;
          background-color: #e5e5e5;
          width: 100%;
          margin-bottom: 10px;
        }
      }

      .sheng {
        display: flex;
      }
      .submit_btn {
        width: 100%;
      }
      .fileShow {
        display: flex;
        span {
          margin-right: 10px;
          font-size: 14px;
        }
        .avatar-uploader {
          display: flex;
          /deep/.el-upload-list--picture-card {
            display: flex;
            .el-upload-list__item {
              width: 100px;
              height: 60px;
            }
          }
          /deep/ .el-upload--picture-card {
            width: 100px;
            height: 60px;
            position: relative;
            .avatar {
              position: absolute;
              top: 0;
              left: 0;
              width: 100px;
              height: 60px;
            }
            i {
              font-size: 20px;
              position: absolute;
              top: 20px;
              left: 40px;
            }
          }
        }
      }
    }
  }
}
</style>
